/**
 * Fetches GUI elements configurations and user context.
 */
import { consumerClient } from "@/shared/services/apollo-clients/consumer-client.ts";
import {
    GuiElementsAndUserDocument,
    GuiElementsAndUserQuery,
} from "@/shared/services/graphql/generated/consumer-graph-types.ts";
import type { GuiElement, GuiElementsResult, GuiElementTypes, ViewContext } from "./context.types.ts";
import { getUiLanguage } from "@/shared/services/providers/language-provider.ts";

export const fetchElements = async (
    context: ViewContext,
    type: GuiElementTypes
): Promise<GuiElementsResult | undefined> => {
    const { data, errors } = await consumerClient.query<GuiElementsAndUserQuery>({
        query: GuiElementsAndUserDocument,
        variables: { guiElementsId: context.view, type },
        fetchPolicy: "cache-first",
    });

    if (errors) {
        console.error("Error fetching GUI elements:", errors);
        return undefined;
    }

    const uiElements: GuiElement[] = data.guiElements.map((guiElement) => ({
        id: guiElement.id,
        ...guiElement.config,
    }));

    const mergedContext = {
        ...context,
        roles: (data.me.effectiveRoles ?? []).filter((role): role is string => role !== null),
        rawClaims: data.me.rawClaims ?? {},
        email: data.me.email,
        language: getUiLanguage(),
    };

    return {
        uiElements,
        context: mergedContext,
    };
};
